/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
exports.PROP_TEXT = "TEXT";
exports.PROP_TEXTAREA = "TEXTAREA";
exports.PROP_SECURE = "SECURE";
exports.PROP_ENUM = "SINGLE_SELECT";
exports.PROP_INTEGRATION = "INTEGRATION";
exports.PROP_APPCONFIG = "APPCONFIG";
exports.PROP_TABLE_SORT_NAME = "name";
exports.PROP_TABLE_SORT_VALUE = "value";
exports.PROP_TABLE_SORT_ACTIONS = "actions";
exports.APP_CONFIG_INTEGRATION = "INTEGRATION";
exports.APP_CONFIG_ENVIRONMENT = "ENVIRONMENT";
exports.APP_CONFIG_COLLECTION = "COLLECTION";
exports.APP_CONFIG_OPTION = "OPTION";
exports.APP_CONFIG_PROPERTY = "PROPERTY";
exports.APP_CONFIG_FEATURE = "FEATURE";
exports.APP_CONFIG_SERVICEID = "appconfig";
exports.APP_CONFIG_OPTION_PROP = "prop";
exports.APP_CONFIG_OPTION_FEATURE = "ff";
exports.PANEL_MODE_ADD = "add";
exports.PANEL_MODE_EDIT = "edit";
exports.PANEL_MODE_HIDDEN = "hidden";
exports.REQUIRED_KEY_FORMAT = /^[-._a-zA-Z0-9]+$/;